import { Checkbox, Spin } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import React from "react";
import styled from "styled-components";
import { Company } from "~/Company";

const StyledSpin = styled.div`
  position: absolute; /* Positions relative to the nearest positioned ancestor (the parent) */
  top: 50%; /* Positions the top edge at the vertical center of the parent */
  left: 50%; /* Positions the left edge at the horizontal center of the parent */
  transform: translate(-50%, -50%); /* Adjusts the position to center the element itself */
`

const StyledDiv = styled.div`
  position: relative;
`

const StyledCheckbox = styled(Checkbox)`
  margin: 5px auto 5px 0 !important;
`;

export namespace Requirements {
  export const DVIREditor = ({
    loading,
    settings,
    onChange,
  }: {
    readonly loading: boolean;
    readonly settings: Company.Settings.DriveAndTrackSettings | null;
    readonly onChange: (
      settings: Company.Settings.DriveAndTrackSettings
    ) => void;
  }) => {
    const handleChange = (
      setting: keyof Company.Settings.DriveAndTrackSettings,
      newValue: boolean
    ) => settings && onChange({ ...settings, [setting]: newValue });

    return (
      <StyledDiv>
        <StyledSpin>
          {loading && <Spin />}
        </StyledSpin>
        <StyledCheckbox
          disabled={!settings}
          checked={settings?.requireNotesForAllDVIRs}
          onChange={({ target: { checked } }: CheckboxChangeEvent) =>
            handleChange("requireNotesForAllDVIRs", checked)
          }
        >
          Require notes for <b>all</b> DVIRs
        </StyledCheckbox>
        <StyledCheckbox
          disabled={!settings}
          checked={settings?.requireImagesForAllDVIRs}
          onChange={({ target: { checked } }: CheckboxChangeEvent) =>
            handleChange("requireImagesForAllDVIRs", checked)
          }
        >
          Require photos for <b>all</b> DVIRs
        </StyledCheckbox>
        <StyledCheckbox
          disabled={!settings}
          checked={settings?.requireDriverToViewAndAcceptCompanyDefectList}
          onChange={({ target: { checked } }: CheckboxChangeEvent) =>
            handleChange(
              "requireDriverToViewAndAcceptCompanyDefectList",
              checked
            )
          }
        >
          Require driver to view and accept company defect lists
        </StyledCheckbox>
      </StyledDiv>
    );
  };
  export const FacialRecognitionEditor = ({
    loading,
    settings,
    onChange,
  }: {
    readonly loading: boolean;
    readonly settings: Company.Settings.DriveAndTrackSettings | null;
    readonly onChange: (
      settings: Company.Settings.DriveAndTrackSettings
    ) => void;
  }) => {
    const handleChange = (
      setting: keyof Company.Settings.DriveAndTrackSettings,
      newValue: boolean
    ) => settings && onChange({ ...settings, [setting]: newValue });

    return (
      <StyledDiv>
        <StyledSpin>
          {loading && <Spin />}
        </StyledSpin>

        <StyledCheckbox
          disabled={!settings}
          checked={settings?.enableFacialRecognitionPairingSuggestions}
          onChange={({ target: { checked } }: CheckboxChangeEvent) =>
            handleChange("enableFacialRecognitionPairingSuggestions", checked)
          }
        >
          Enable facial recognition pairing suggestions for drivers
        </StyledCheckbox>
      </StyledDiv>
    );
  };
}